import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import Footer from '../../common/Footer'
import { bangaloreSightSeeingData } from './tourPackageData'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'

const BangaloreSightSeeing = () => {
    return (
        <>
            <Header />
            <CommonHeroSection title="Bangalore Sight Seeing" />
            <CommonBreadcrumb items={["Bangalore Sight Seeing"]} />
            <DynamicTourSection {...bangaloreSightSeeingData} />
            <Footer />
        </>
    )
}

export default BangaloreSightSeeing
